import React from 'react';

import './styles.scss';

const SiteAlert = ({ children, text, className }) => {
  return (
    <div className={`site-alert ${className}`} aria-label="banner anuncio" role="group">
      <div role="alert" className="site-alert__content">
        {children || text}
      </div>
    </div>
  );
};

export default SiteAlert;
